// src/api/axiosInstance.js
import axios from 'axios';
// import { globalAdminUrl } from 'src/pages/services/globalApi';
import { globalAdminUrl } from '../pages/services/globalApi';
// import { store } from '../store';

// Create instance
const axiosInstance = axios.create({
  baseURL: globalAdminUrl, // replace with your server URL
  headers: {
    'Content-Type': 'application/json'
  }
  //   timeout: 10000 // optional: 10 seconds timeout
});

// ✅ REGISTER INTERCEPTOR ONCE
axiosInstance.interceptors.request.use(
  (config) => {
    if (config.skipAuth) {
      delete config.headers.Authorization;
      return config;
    }
    // 🔥 Always read latest token
    const persistedRoot = sessionStorage.getItem('persist:root');

    if (persistedRoot) {
      const parsedRoot = JSON.parse(persistedRoot);
      const login = JSON.parse(parsedRoot.Login || '{}');
      const token = login?.login_data?.jwt;

      if (!config.headers.Authorization) {
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          delete config.headers.Authorization;
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Optional: global 401 handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      sessionStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
